import { render, staticRenderFns } from "./criteriosCasayes.vue?vue&type=template&id=d8924bc2"
import script from "./criteriosCasayes.vue?vue&type=script&lang=js"
export * from "./criteriosCasayes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports